import { render, staticRenderFns } from "./PurchaseReturnHistory.vue?vue&type=template&id=ca0d03f2&"
import script from "./PurchaseReturnHistory.vue?vue&type=script&lang=js&"
export * from "./PurchaseReturnHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports